import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, CircularProgress, TextField } from '@mui/material';
import { emailValidator } from '../../util/validator';
import { useState } from 'react';
import { consoleToLog, getServiceName } from '../../util/AppUtil';
import { useSnackbar } from 'notistack';
import { forgotPasswordApi } from '../../services/authService';

const ForgotPasswordModal = (props) => {
    const [femail, setFEmail] = useState('');
    const [femailInValid, setFEmailInValid] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const service_name = getServiceName(window.location.href);

    const onSubmit = () => {
        if (!femail) {
            setFEmailInValid(true);
            return;
        }
        const isEmailValid = emailValidator(femail);
        if (!isEmailValid) {
            setFEmailInValid(true);
            return;
        }
        setApiLoading(true);
        forgotPasswordApi(femail, service_name)
            .then((response) => {
                const res = response.data;
                consoleToLog("Response forgotPasswordApi: ", res);
                enqueueSnackbar(res.message, { 
                    variant: 'success',
                });
                setFEmail('');
                setApiLoading(false);
                props.handleClose();

            })
            .catch((e) => {
                consoleToLog("forgotPasswordApi error", e.response);
                setApiLoading(false);
                if (e.response.data && e.response.data.message) {
                    enqueueSnackbar(e.response.data.message, { 
                    variant: 'error',
                    });
                    return false;
                }
            })
        
    }
    return(
        <Dialog open={props.isOpen} 
            onClose={props.handleClose} 
            aria-labelledby="form-dialog-title">

            <DialogTitle id="form-dialog-title" 
            style={{paddingBottom: "0px", paddingTop: "30px", paddingLeft: "30px", paddingRight: "30px"}}>Forgot Your Password?</DialogTitle>
            
            <DialogContent style={{paddingTop: "10px", paddingLeft: "30px", paddingRight: "30px"}}>
                <DialogContentText style={{fontSize: "12px"}}>
                   { `Enter the email you used to create your ${props.isAppDomainTyno ? 'Tyno' : 'eProcessify'} account and we'll send you an email to reset your password.`}
                </DialogContentText>
                <TextField
                    style={{marginTop: "20px"}}
                    autoFocus
                    variant="outlined"
                    size="small"
                    margin="dense"
                    id="name"
                    label="Email Address"
                    type="email"
                    fullWidth
                    error={femailInValid}
                    helperText={femailInValid ? "* Email is invalid!" : ''}
                    onChange={e => { 
                        setFEmail(e.target.value);
                        setFEmailInValid(false);
                    }}
                    onKeyPress={(ev) => {
                    if (ev.key === 'Enter') {
                        onSubmit();
                        ev.preventDefault();
                    }
                    }}
                />
            </DialogContent>

            <DialogActions style={{marginTop: "15px", paddingBottom: "30px", paddingRight: "30px"}}>
                <Button onClick={props.handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={onSubmit} color="primary" variant="contained" disabled={apiLoading}>
                    {apiLoading && <CircularProgress size={16} style={{marginRight:'8px', color:'#fff'}}/>}
                    Reset Password
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default ForgotPasswordModal;